import { useState } from 'react';
import { faqs } from '@/mocks/faq';
import type { FaqItem } from '@/pages/home/types';

const items: FaqItem[] = faqs;

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-full mb-4">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
            关于爆料网的几个说明
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            我们更希望做一个“把信息讲清楚”的地方。点击右侧问题即可展开查看详细说明。
          </p>
          <div className="mt-6 flex items-center gap-3 p-4 rounded-lg bg-accent-50 border border-accent-200">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-900">
              <i className="ri-lightbulb-line"></i>
            </span>
            <p className="text-xs text-foreground-700 leading-relaxed">
              有问题没被解答？在下方订阅时备注你的疑问，编辑会不定期集中回复。
            </p>
          </div>
        </div>

        <div className="lg:col-span-2 flex flex-col gap-3">
          {items.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border transition-colors ${
                  open ? 'bg-background-100 border-primary-300' : 'bg-background-50 border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                    <span
                      className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                        open ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                    </span>
                  </button>
                </h3>
                <div className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-72' : 'max-h-0'}`}>
                  <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}